import React, { useState } from 'react';
import api from '../../config/axios';
import { useShop } from '../../contexts/ShopContext';
import './Auth.css';

interface LoginProps {
  onSwitchToRegister: () => void;
  onLoginSuccess: (token: string, user: any) => void;
}

const Login: React.FC<LoginProps> = ({ onSwitchToRegister, onLoginSuccess }) => {
  const { name, logoUrl } = useShop();
  const [formData, setFormData] = useState({ shopCode: '', username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const slug = formData.shopCode.trim().toLowerCase();
      localStorage.setItem('shopSlug', slug);
      const response = await api.post('/api/auth/login', {
        username: formData.username,
        password: formData.password,
        shopSlug: slug,
      });
      if (response.data.success) {
        const { token, user } = response.data.data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        onLoginSuccess(token, user);
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Đăng nhập thất bại';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>
            {logoUrl
              ? <img src={logoUrl} alt={name} className="auth-logo-img" />
              : <img src="/logo-mark.png" alt={name || 'T-POS'} className="auth-logo-img" />}
            {name || 'T-POS'}
          </h2>
          <p>Đăng nhập vào hệ thống</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="shopCode">Mã cửa hàng</label>
            <input
              type="text"
              id="shopCode"
              name="shopCode"
              value={formData.shopCode}
              onChange={handleChange}
              placeholder="Nhập mã cửa hàng"
              autoCapitalize="none"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="username">Tên đăng nhập</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Nhập tên đăng nhập"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mật khẩu</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Nhập mật khẩu"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </button>
        </form>
        <div className="auth-footer">
          <p>
            Chưa có tài khoản?{' '}
            <button onClick={onSwitchToRegister} className="link-button">
              Đăng ký ngay
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 